export const ENHANCE_USER_ROLES_RESET_STATE = 'ENHANCE_USER_ROLES_RESET_STATE';
export const ENHANCE_USER_ROLES_CURRENT_ITEM = 'ENHANCE_USER_ROLES_CURRENT_ITEM';

export const ENHANCE_USER_ROLES_REQUEST_LOADING = 'ENHANCE_USER_ROLES_REQUEST_LOADING';
export const ENHANCE_USER_ROLES_REQUEST_SUCCESS = 'ENHANCE_USER_ROLES_REQUEST_SUCCESS';
export const ENHANCE_USER_ROLES_REQUEST_FAILED = 'ENHANCE_USER_ROLES_REQUEST_FAILED';

export const ENHANCE_USER_ROLES_CURRENT_ACTION = 'ENHANCE_USER_ROLES_CURRENT_ACTION';
export const ENHANCE_USER_ROLES_RESET_ACTION = 'ENHANCE_USER_ROLES_RESET_ACTION';